import React from "react";
import { ArrowForward as ArrowForwardIcon } from "@mui/icons-material";
import { useWidgetMsg } from "../../hooks/widget/useWidgetMsg";
import { MAX_SUGGESTIONS } from "../../utils/suggestedActions";

/**
 * spec-langchain-native-runtime 09b — the reply's suggested next step as an outlined chip below the
 * bubble. A native `<button>` (Tab-focusable, Enter and Space activate it) whose accessible name is
 * "Send: {label}"; the `reason` is a hover title only (PRD §9), never announced on its own. No live
 * region here: the transcript's one polite region (Chat.jsx, D-17) is the only one.
 *
 * `actions` are already sanitized (`utils/suggestedActions`); an empty list renders nothing.
 */
export default function SuggestedActions({ actions = [], disabled = false, onSelect }) {
	const { msg, isRtl } = useWidgetMsg();
	if (!Array.isArray(actions) || actions.length === 0) return null;
	return (
		<div
			className="nba-chips"
			role="group"
			aria-label={msg("suggestions.title", "Suggested next steps")}
			dir={isRtl ? "rtl" : undefined}
		>
			{actions.slice(0, MAX_SUGGESTIONS).map((action) => (
				<button
					key={action.id}
					type="button"
					className="nba-chip"
					title={action.reason || undefined}
					aria-label={msg("suggestions.send", "Send: {label}", { label: action.label })}
					disabled={disabled}
					onClick={() => onSelect?.(action)}
				>
					<span className="nba-chip-label">{action.label}</span>
					<ArrowForwardIcon className="nba-chip-icon" aria-hidden="true" sx={{ fontSize: 14 }} />
				</button>
			))}
		</div>
	);
}
